// getPopupNotificationData.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import { DETAIL_SELECT_PATH_PREFIX } from '../resource/popupNotificationConstants.js';
import getOperationData from '../selector/getOperationData.js';

/**
 * Select popup notification data by state
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} notificationTag - popup notification tag.
 * @return {Object} The notification data.
 */
const getPopupNotificationData = createCachedSelector(
  (state, notificationTag) =>
    getOperationData(state, [...DETAIL_SELECT_PATH_PREFIX, notificationTag]),
  state => getOperationData(state, ['oembed']),
  (notification = {}, oembed = {}) => {
    const oembedData = oembed[notification?.link] || {};
    return Object.assign(notification, { oembed: oembedData });
  }
)((state, notificationTag) => `${notificationTag}`);

export default getPopupNotificationData;
